// @flow
import { createContext } from 'react';

export const FlinkPoolWorkloadContext = createContext({});
